<template>
  <div class="messages-container col-12">
    <tabs />
    <div class="messages-header col-12">
      <span class="title">TEMPLATES</span>
      <div class="create-button" @click="routeToTemplate()">
        <i class="fas fa-plus" style="margin-right: 5px;" />
        <span>CREATE NEW TEMPLATE</span>
      </div>
    </div>
    <div class="filters-section">
      <input 
        class="search-input" 
        type="text" 
        v-model="searchFilter" 
        placeholder="Search template name..."
      />
    </div>
    <div class="flex1">
      <div class="row titles">
        <div class="col-md-4 col-12">
          Template Name
        </div>
        <div class="col-md-2 col-12">
          Template Id
        </div>
        <div class="col-md-1 col-12 text-center sortable" @click="changeSortParams('sent')">
          Sent {{ getSortIcon('sent') }}
        </div>
        <div class="col-md-1 col-12 text-center sortable" @click="changeSortParams('clicked')">
          Clicked {{ getSortIcon('clicked') }}
        </div>
        <div class="col-md-1 col-12 text-center sortable" @click="changeSortParams('ctr')">
          CTR {{ getSortIcon('ctr') }}
        </div>

        <div class="col-md-2 col-12 text-center">
          Actions
        </div>
      </div>
      <div class="row line-hover" v-for="template in filteredAndSortedTemplates" :key="`template-${template.id}`"
        @click="$router.push({ name: 'MessagesTemplate', params: { id: template.id } })">
        <div class="col-md-4 col-12">
          {{ template.name }}
        </div>
        <div class="col-md-2 col-12" @click.stop="copyToClipBoard(template.id);">
          {{ template.id }}
        </div>
        <div class="col-md-1 col-12 text-center">
          {{setStatistics(template.id, "sent")}}
        </div> 
        <div class="col-md-1 col-12 text-center">
          {{setStatistics(template.id, "clicked")}}
        </div> 
        <div class="col-md-1 col-12 text-center">
          {{setStatistics(template.id, "ctr")}}
        </div>
        <div class="col-md-2 col-12 text-center">
          <popup-menu>
            <template v-slot:trigger>
              <i class="fas fa-ellipsis-v" />
            </template>
            <template v-slot:content>
              <a style="cursor: pointer; color: white; margin: 5px 0;"
                @click.stop="$router.push({ name: 'MessagesTemplate', params: { id: template.id } })">
                <i class="fas fa-pen-square" />
                Edit & View
              </a>
              <a style="cursor: pointer; color: white; margin: 5px 0;" @click.stop="() => duplicateTemplate(template)">
                <i class="fas fa-copy" />
                Duplicate
              </a>
              <a style="cursor: pointer; color: red; margin: 5px 0;" @click.stop="() => deleteTemplate(template.id)">
                <i class="fas fa-ban" />
                Delete
              </a>
            </template>
          </popup-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "@/views/PushNotification/Tabs";
import PopupMenu from "@/views/PushNotification/UIComponents/PopupMenu";
import notify from "@/util/notification";
import copyToClipBoard from "@/util/copyToClipboard";
import {ctr} from "@/util/ctr";
export default {
  name: "Templates",
  components: {
    Tabs,
    PopupMenu
  },
  data(){
    return{
      ctr,
      searchFilter: '',
      sortParams: {
        field: 'sent',
        direction: 'DESC'
      }
    }
  },
  computed: {
    templates() {
      return this.$store.getters.templateMessages
    },
    filteredAndSortedTemplates() {
      let filtered = this.templates.filter(template => {
        const searchMatch = template.name.toLowerCase().includes(this.searchFilter.toLowerCase());
        return searchMatch;
      });
      return filtered.sort(this.sorter);
    }
  },
  // created() {
  //   console.log("created çalıştı");
  //   this.setStatistics();
  // },
  methods: {
    changeSortParams(field) {
      if (this.sortParams.field === field) {
        this.sortParams.direction = this.sortParams.direction === 'ASC' ? 'DESC' : 'ASC';
      } else {
        this.sortParams = { field, direction: 'DESC' };
      }
    },
    getSortIcon(field) {
      if (this.sortParams.field !== field) return '';
      return this.sortParams.direction === 'ASC' ? '↑' : '↓';
    },
    sorter(a, b) {
      const { field, direction } = this.sortParams;
      let aValue, bValue;

      const aStats = this.$store.getters.allMessageStatistics(a.id);
      const bStats = this.$store.getters.allMessageStatistics(b.id);

      switch(field) {
        case 'sent':
          aValue = aStats.sent || 0;
          bValue = bStats.sent || 0;
          break;
        case 'clicked':
          aValue = aStats.clicked || 0;
          bValue = bStats.clicked || 0;
          break;
        case 'ctr':
          aValue = typeof aStats.ctr === 'string' ? 0 : aStats.ctr || 0;
          bValue = typeof bStats.ctr === 'string' ? 0 : bStats.ctr || 0;
          break;
        default:
          return 0;
      }

      if (aValue < bValue) return direction === 'ASC' ? -1 : 1;
      if (aValue > bValue) return direction === 'ASC' ? 1 : -1;
      return 0;
    },
    setStatistics(templateId, type){
      const stats = this.$store.getters.allMessageStatistics(templateId)
      console.log(stats);
      return stats[type]
    },
    // totalSentCount(templateId){
    //   console.log("runs");
    //   let totalSentCount = 0;
    //   this.messages.forEach(message => {
    //     // if ab test
    //     if(message.messages[1]){
    //       if(message.messages[0].templateId == templateId){
    //         totalSentCount += message.statistics.a.sent
    //       }
    //       if(message.messages[1].templateId == templateId){
    //         totalSentCount += message.statistics.b.sent
    //       }
    //     }
    //     else if(message.messages[0].templateId == templateId){
    //       totalSentCount += message.statistics.sent
    //     }
    //   });
    //   return totalSentCount
    // },
    // totalClickedCount(templateId){
    //   let totalClickedCount = 0;
    //   this.messages.forEach(message => {
    //     // if ab test
    //     if(message.messages[1]){
    //       if(message.messages[0].templateId == templateId){
    //         totalSentCount += message.statistics.a.clicked
    //       }
    //       if(message.messages[1].templateId == templateId){
    //         totalSentCount += message.statistics.b.clicked
    //       }
    //     }
    //     else if(message.messages[0].templateId == templateId){
    //       totalSentCount += message.statistics.clicked
    //     }
    //   });
    //   return totalClickedCount
    // },
    copyToClipBoard(id) {
      copyToClipBoard(id)
    },
    routeToTemplate() {
      if (!this.canSendPushNotifications && !this.canCreateDraftMessages) {
        return notify('You are not authorized to send push notifications or create draft messages', "error")
      }
      this.$router.push({ name: 'MessagesTemplate' })
    },
    template(id) {
      const template = this.templates.find((item) => item.id == id);
      return template ? template : {};
    },
    duplicateTemplate(template) {
      const payload = { ...template }
      payload.name += '_copy'
      delete payload.id
      this.$store.dispatch('configAdd', { type: 'message', payload });
    },
    deleteTemplate(id) {
      if (
        confirm(
          `You are trying to delete "${this.template(id).name
          }" template. Are you sure?`
        )
      ) {
        this.$store.dispatch('configDelete', { type: 'message', payload: id });
      }
    }
  }
}
</script>

<style scoped>
.messages-header {
  margin: 25px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 24px;
}

.create-button {
  cursor: pointer;
  border-radius: 28px;
  background: #03B3DA;
  color: white;
  padding: 10px 15px;
  font-size: 14px;
}

.filters-section {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.search-input {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  min-width: 200px;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.sortable {
  cursor: pointer;
  user-select: none;
}

.sortable:hover {
  opacity: 0.8;
}
</style>